import { createFileRoute } from "@tanstack/react-router";
import AdminPartsShipments from "@/pages/admin/AdminPartsShipments";

export const Route = createFileRoute("/_adminLayout/admin/parts/shipments/")({
  component: AdminPartsShipments,
});